import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  createCategorySuccess,
  createCategoryFailure,
  getParentCategorySuccess,
  getParentCategoryFailure,
  getSubCategorySuccess,
  getSubCategoryFailure,
  getCategoryListSuccess,
  getCategoryListFailure,
  updateCategorySuccess,
  updateCategoryFailure,
  updateStatusCategoryFailure,
  updateStatusCategorySuccess,
  viewCategorySuccess,
  viewCategoryFailure,
  getChildCategoryListSuccess,
  getChildCategoryListFailure,
  getRenewableListSuccess,
  getRenewableFailure,
  getRenewableLessonTypeSuccess,
  getRenewableLessonTypeFailure,
  getRenewableLessonTypeProductValueSuccess,
  getRenewableLessonTypeProductValuefailure,
  subcategoryproductssuccess,
  subcategoryproductsfailure,
  getParentCategoryByChildSuccess,
  getParentCategoryByChildFailure
} from "../../actions";
import {
  CREATE_CATEGORY,
  PARENT_CATEGORY_LIST,
  SUB_CATEGORY_LIST,
  GET_CATEGORY_LIST,
  PARENT_CATEGORY_BY_CHILD,
  UPDATE_CATEGORY,
  UPDATE_STATUS_CATEGORY,
  VIEW_CATEGORY,
  CHILD_CATEGORY_LIST,
  RENEWABLE_LESSON_LIST,
  RENEWABLE_LESSON_TYPE_LIST,
  RENEWABLE_LESSON_ADD_TYPE,
  GET_PARENT_SUB_CATEGORY_PRODUCT,
} from "../../Actions/types";
import api from "../../../helper/api";

function* createCategory(action) {
  try {
    const response = yield api.post(
      "/admin/category/add-category",
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createCategorySuccess({ createCategoryData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createCategoryFailure({ createCategoryError: e }));
  }
}

function* parentCategoryList(action) {
  try {
    const response = yield api.get("/admin/category/parent-category-list");
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getParentCategorySuccess({
          getParentCategoryData: response?.data?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getParentCategoryFailure({ getParentCategoryError: e }));
  }
}
function* subCategoryList(action) {
  console.log(action);
  try {
    const response = yield api.post(
      `/admin/category/child-category-list`,
      action?.payload?.payload
    );

    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getSubCategorySuccess({
          getSubCategoryData: response?.data?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getSubCategoryFailure({ getSubCategoryError: e }));
  }
}

function* parentByChildCategory(action) {
  try {
    const response = yield api.post(
      `/admin/category/parent-category-by-child`,
      action?.payload?.form
    );

    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getParentCategoryByChildSuccess({
          getParentCategoryByChild: response?.data?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getParentCategoryByChildFailure({ getSubCategoryError: e }));
  }
}

function* childCategoryList(action) {
  const form = {
    orderBy: action?.payload?.form?.orderBy,
    order: action?.payload?.form?.order,
    limit: action?.payload?.form?.limit,
    page: action?.payload?.form?.page,
    search: action?.payload?.form?.search,
  };
  try {
    const response = yield api.post(
      `/admin/category/child-listing/${action?.payload?.form?.categoryId}`,
      form
    );

    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getChildCategoryListSuccess({
          getChildCategoryListData: response?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getChildCategoryListFailure({ getChildCategoryListError: e }));
  }
}

function* getCategoryList(action) {
  try {
    const response = yield api.post(
      "/admin/category/category-listing",
      action?.payload?.form
    );
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getCategoryListSuccess({ getCategoryListData: response?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getCategoryListFailure({ getCategoryListError: e }));
  }
}

function* updateCategory(action) {
  const form = {
    description: action?.payload?.form?.description,
    image: action?.payload?.form?.image,
    categoryName: action?.payload?.form?.categoryName,
    type:action?.payload?.form?.type
  };
  try {
    const response = yield api.put(
      `admin/category/edit-category/${action?.payload?.form?.id}`,
      form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateCategorySuccess({ updateCategoryData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateCategoryFailure({ updateCategoryError: e }));
  }
}

function* updateStatusCategory(action) {
  try {
    const response = yield api.put(
      `/admin/category/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusCategorySuccess({
          updateStatusCategoryData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateStatusCategoryFailure({ updateStatusCategoryError: e }));
  }
}

function* viewCategory(action) {
  try {
    const response = yield api.get(
      `admin/category/view-category/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewCategorySuccess({ viewCategoryData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewCategoryFailure({ viewCategoryError: e }));
  }
}

// renewable lesson list
function* renewableLessonList(action) {
  try {
    const response = yield api.post(
      "/admin/products/lesson-list",
      action?.payload?.form
    );
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getRenewableListSuccess({
          getRenewableLessonData: response?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getRenewableFailure({ getRenewableLessonError: e }));
  }
}

// renewable sub lesson list
function* renewableLessonTypeList(action) {
  try {
    const response = yield api.post(
      `/admin/products/sub-lesson-list/${action?.payload?.payload}`,
      action?.payload?.form
    );
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getRenewableLessonTypeSuccess({
          getRenewableLessonTypeData: response?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getRenewableLessonTypeFailure({ getRenewableLessonError: e }));
  }
}

function* subcategoryfetchproduct(action) {
  try {
    const response = yield api.post(
      `/admin/products/product-by-category`,
      action?.payload?.payload
    );
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        subcategoryproductssuccess({
          getsubcategoryproduct: response?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(subcategoryproductsfailure({ getsubcategoryproducterror: e }));
  }
}



function* createCategoryWatcher() {
  yield takeLatest(CREATE_CATEGORY, createCategory);
}
function* parentCategoryWatcher() {
  yield takeLatest(PARENT_CATEGORY_LIST, parentCategoryList);
}
function* subCategoryWatcher() {
  yield takeLatest(SUB_CATEGORY_LIST, subCategoryList);
}
function* parentCategoryByChildWatcher() {
  yield takeLatest(PARENT_CATEGORY_BY_CHILD, parentByChildCategory);
}
function* getCategoryListWatcher() {
  yield takeLatest(GET_CATEGORY_LIST, getCategoryList);
}
function* updateCategoryWatcher() {
  yield takeLatest(UPDATE_CATEGORY, updateCategory);
}
function* updateStatusCategoryWatcher() {
  yield takeLatest(UPDATE_STATUS_CATEGORY, updateStatusCategory);
}
function* viewCategoryWatcher() {
  yield takeLatest(VIEW_CATEGORY, viewCategory);
}
function* getChildCategoryListWatcher() {
  yield takeLatest(CHILD_CATEGORY_LIST, childCategoryList);
}
function* renewableLessonListWatcher() {
  yield takeLatest(RENEWABLE_LESSON_LIST, renewableLessonList);
}
function* renewableLessonTypeListWatcher() {
  yield takeLatest(RENEWABLE_LESSON_TYPE_LIST, renewableLessonTypeList);
}
function* subcategoryfetchproductWatcher() {
  yield takeLatest(GET_PARENT_SUB_CATEGORY_PRODUCT, subcategoryfetchproduct);
}


export default function* categoryManagementSaga() {
  yield all([
    createCategoryWatcher(),
    parentCategoryWatcher(),
    subCategoryWatcher(),
    getCategoryListWatcher(),
    updateCategoryWatcher(),
    updateStatusCategoryWatcher(),
    viewCategoryWatcher(),
    getChildCategoryListWatcher(),
    renewableLessonListWatcher(),
    renewableLessonTypeListWatcher(),
    subcategoryfetchproductWatcher(),
    parentCategoryByChildWatcher()
  ]);
}
